import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteProject } from '../../../../_global/fragments/generated/CompleteProject';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type DeleteProjectsMutationVariables = Types.Exact<{
  input: Types.DeleteProjectsInput;
}>;


export type DeleteProjectsMutation = { __typename?: 'Mutation', deleteProjects: { __typename?: 'DeleteProjectsPayload', successful: boolean, result?: Array<{ __typename?: 'DeleteProjectPayloadTemp', successful: boolean, result?: { __typename?: 'Project', id: string, archivedAt?: string | null, archivedFileCount?: number | null, deletedAt?: string | null, description?: string | null, fileCount: number, folderCount: number, ignoreArchive: boolean, insertedAt: string, isLoading?: boolean | null, isWorkfront?: boolean | null, lastUpdated: string, memberCount?: number | null, name: string, private: boolean, rootAssetId: string, storage: number, updatedAt?: string | null, workspaceId: string, notificationsEnabled?: boolean | null, images: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null }, workspace?: { __typename?: 'Workspace', id: string, accountId?: string | null, name: string, images?: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null } | null } | null } | null } | null> | null } };


export const DeleteProjects = /*#__PURE__*/ gql`
    mutation DeleteProjects($input: DeleteProjectsInput!) {
  deleteProjects(input: $input) {
    result {
      result {
        ...CompleteProject
      }
      successful
    }
    successful
  }
}
    ${CompleteProject}` as unknown as DocumentNode<DeleteProjectsMutation, DeleteProjectsMutationVariables>;

          

          export const useDeleteProjectsMutation = (options?:MutationHookOptions<DeleteProjectsMutation, DeleteProjectsMutationVariables>) => useMutation(DeleteProjects, options);
          

          export type DeleteProjectsMutationOptions = MutationHookOptions<DeleteProjectsMutation, DeleteProjectsMutationVariables>;

          

          export type DeleteProjectsMutationResult = ReturnType<typeof useDeleteProjectsMutation>[1];

          
